// extracted by mini-css-extract-plugin
export default {"searchInputField":"search_searchInputField__xjjf6","searchSugeestionsWrapper":"search_searchSugeestionsWrapper__Y-YnB"};